import { logToServer, LOG_LEVEL, LogLevel } from 'app/business-logic/services/log-service/logToServer';

export function logErrorToServer({
  componentStack,
  error,
  logLevel,
}: {
  componentStack?: string;
  error: string;
  logLevel?: LogLevel[keyof LogLevel];
}) {
  logToServer({
    level: logLevel ?? LOG_LEVEL.Fatal,
    url: window.location.href,
    message: `[evs-omnis-frontend] ${error}`,
    exception: componentStack ?? '',
  });
}
